import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ResourceType } from '@anecdotes/data-store';
import { FocusingService } from '@anecdotes/focusing-mechanism';
import { AppRoutes, MyAnecdotesRoutesSegments } from '@anecdotes/configuration-data-access';

@Injectable()
export class MyAnecdotesNavigator {
  constructor(private router: Router, private focusingService: FocusingService) {}

  async navigateToTasksAndReviews(collaborationId?: string): Promise<void> {
    await this.router.navigate([`/${AppRoutes.MyAnecdotes}/${MyAnecdotesRoutesSegments.TasksAndReviews}`]);

    if (collaborationId) {
      this.focusingService.focusSingleResource(ResourceType.TaskOrReview, collaborationId);
    }
  }
}
